export const RoutePaths = {
  // Public routes
  HOME: "/",
  PRICING: "/pricing",
  ABOUT_US: "/about-us",
  // JOIN_WHITELIST: "/join-whitelist",
  SIGN_IN: "/signin",
  SIGN_UP: "/signup",
  LOGIN_COMPANY_INVITED_NEW: "/company-invite/new",
  LOGIN_COMPANY_INVITED_EXISTING: "/company-invite/existing",
  PASSWORD_RECOVERY: "/password-recovery",

  // Dashboard routes
  APPLICATIONS: "/applications",
  COMPANY: "/company",
  COMPANY_USERS: "/company/users",
  COMPANY_NOTIFICATIONS: "/company/notifications",
  COMPANY_SUBSCRIPTION: "/company/subscription",
  COMPANY_SUBSCRIPTION_PLANS: "/company/subscription/plans",
  ADMIN: "/admin",
  ADMIN_USERS: "/admin/users",
  ADMIN_COMPANIES: "/admin/companies",
  ADMIN_COMPANY_DETAILS: "/admin/companies/:companyId",
  USER: "/me",
  SETTINGS: "/settings",
  SUPPORT: "/support",
  INTERNAL_CONTACT_US: "/internal-contact-us",

  // Error routes
  NOT_FOUND: "*",
} as const;

export type RoutePathItem = (typeof RoutePaths)[keyof typeof RoutePaths];
